// extracted by mini-css-extract-plugin
export default {"sobreNosParte1":"SobreNosParte1_sobreNosParte1__TW4h2"};